import { Component, OnInit, Input } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ActivatedRoute, Router } from "@angular/router";
import { JqHelper } from "src/app/common/jq-helper";
import { UnitOfWorkService } from "src/app/services/api/uow/unit-of-work.service";
import { HttpClient } from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import {
  G_InventoryTransferViewModel,
  G_InventoryDetailsViewModel,
} from "src/app/viewmodels/g-inventory/inventory-transfer.viewmodel";
import Swal from "sweetalert2";
import { LocalStorageService } from "src/app/services/common/local-storage.service";
import { GInventoryDetailModel, SaveInventoryTransfersRequest } from "src/app/viewmodels/g-purchase/GPurchaseViewModel";

@Component({
  selector: "app-stock-form",
  templateUrl: "./stock-form.component.html",
  styleUrls: ["./stock-form.component.scss"],
})
export class StockFormComponent implements OnInit {
  @Input() public bsmRef: BsModalRef;
  public inventoryTransferVm = new SaveInventoryTransfersRequest();
  public InventoryDetailList: Array<GInventoryDetailModel> = [];
  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public userAssingedWareHouse: Array<any> = [];
  public selectedStock: Array<any>;
  public maxDate = new Date();
  loading: boolean = false;
  public user: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) {
    this.inventoryTransferVm.transferDate = new Date();
  }

  ngOnInit() {
    this.user = this._localStorageService.get("ussr");
    this.getWareHouse();
  }

  getWareHouse() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.userAssingedWareHouse = res.result;
        resolve(res);
      });
    });
  }
  public isSame: boolean = false;
  public isSelect: boolean = false;
  onSelectWarehouse() {
    debugger
    if (
      this.inventoryTransferVm.fromWareHouse !== undefined &&
      this.inventoryTransferVm.toWareHouse !== undefined
    ) {
      if (
        this.inventoryTransferVm.fromWareHouse.id ===
        this.inventoryTransferVm.toWareHouse.id
      ) {
        this.isSame = true;
      } else {
        this.isSame = false;
      }
      this.isSelect = true;
    }
  }
  fetchListByWarehouse() {
    this.loading = true;
    this._uow.gPurchaseService.GetInventoryTransfersByWarehouseIdAsync(this.inventoryTransferVm.fromWareHouse.id,this.inventoryTransferVm.toWareHouse.id).subscribe(
      (res: any) => {
        console.log("res", res);
        this.InventoryDetailList = res.result;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }
  transferStock(stock,index) {
    if(stock.transferQuantity > stock.fromOldQuantity){
      console.log('runnng');
      return;
   }
    if (this.selectedStock == undefined ||  this.selectedStock.length < 1) {
      this.selectedStock =[];
    }
    
    if (this.selectedStock.length > 0) {
      
      let selected = this.selectedStock.find(
        (x) => x.item.id === stock.item.id
      );
      if(selected !== undefined){
        
        if (stock.transferQuantity > 0) {
            
          selected.fromNewQuantity = stock.fromOldQuantity - stock.transferQuantity;
          selected.toNewQuantity = stock.toOldQuantity + stock.transferQuantity;
        
        }
        else{
          this.selectedStock.splice(this.selectedStock.indexOf(selected),1);  
        }
      }
      else{
        if (stock.transferQuantity > 0) {
          stock.fromNewQuantity = stock.fromOldQuantity - stock.transferQuantity;
          stock.toNewQuantity = stock.toOldQuantity + stock.transferQuantity;
          this.selectedStock.push(stock);
        }
      }
    } else {
      
      if (stock.transferQuantity > 0) {
        stock.fromNewQuantity = stock.fromOldQuantity - stock.transferQuantity;
        stock.toNewQuantity = stock.toOldQuantity + stock.transferQuantity;
        this.selectedStock.push(stock);
      }
    }
   
  }
  saveOrUpdate() {
    // this._jq.showSpinner(true);
    this.spinner.show();
    this.inventoryTransferVm.inventoryDetailList = this.selectedStock;
    this._uow.gPurchaseService
      .SaveGTransferInventoryAsync(this.inventoryTransferVm)
      .toPromise()
      .then((res: any) => {
        console.log(res);
        this.spinner.hide();
        Swal.fire("Created!", "Stock Created/Updated!", "success");
        this.bsmRef.hide();
      })
      .catch((error) => {
        this.spinner.hide();
        Swal.fire("Failure!", "Stock Not Updated!", "error");
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
      });
  }
}
